import React from 'react'
import { PageContent, MapWidget, MapMenu, MapItem, MapLayer, MapOverlay, MapTabs, MapTab, MessageTooltip, Text, PageFooter, Message, Image } from 'components/library'
import { Layer, Popup } from 'components/library/widgets/map/components'
import { checkIE11 } from 'helpers'
import Dropdown from 'content/components/dropdown/Dropdown'
import DropdownMix from 'content/components/dropdown/DropdownMix'
import Legend from 'content/components/legend/Legend'
import mapBaseImage from 'components/library/widgets/map/assets/baseMap-01.svg'
import './Aspect03.css'
import * as assets from './assets'

const tab01Layers = [
  {
    id: 1,
    label: 'Rijbaan A1A',
    layer1: {
      url: assets.img01,
      bounds: [[0, 0], [3556, 3406]],
      center: [1208,1178],
      zoom: 0.65,
    },
    layer2: {
      url: assets.img02,
      bounds: [[0, 0], [3556, 3406]],
      center: [1190,1208],
      zoom: 0.54,
    }
  },
  {
    id: 2,
    label: 'Rijbaan A1B',
    layer1: {
      url: assets.img03,
      bounds: [[0, 0], [3556, 3406]],
      center: [1232,1222],
      zoom: 0.65,
    },
    layer2: {
      url: assets.img04,
      bounds: [[0, 0], [3556, 3406]],
      center: [1190,1208],
      zoom: 0.54,
    }
  },
  // {
  //   id: 3,
  //   label: 'Rijbaan A1C',
  //   layer1: {
  //     url: assets.img05a,
  //     bounds: [[0, 0], [3556, 3406]],
  //     center: [1238,1252],
  //     zoom: 0.65,
  //   },
  //   layer2: {
  //     url: assets.img05b,
  //     bounds: [[0, 0], [3556, 3406]],
  //     center: [1190,1208],
  //     zoom: 0.54,
  //   }
  // },
  {
    id: 4,
    label: 'Rijbaan A2',
    layer1: {
      url: assets.img06a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1294,1330],
      zoom: 0.87,
    },
    layer2: {
      url: assets.img06b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1228,1315],
      zoom: 0.54,
    }
  },
  {
    id: 5,
    label: 'Rijbaan A4',
    layer1: {
      url: assets.img07a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1475,1612],
      zoom: 0.65,
    },
    layer2: {
      url: assets.img07b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1407,1557],
      zoom: 0.54,
    }
  },
  {
    id: 6,
    label: 'VOP C13',
    layer1: {
      url: assets.img001a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1522,1725],
      zoom: 0.86,
    },
    layer2: {
      url: assets.img001b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1498,1707],
      zoom: 0.54,
    }
  },
  {
    id: 7,
    label: 'VOP C15',
    layer1: {
      url: assets.img002a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1516,1714],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img002b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1498,1693],
      zoom: 0.54,
    }
  },
  {
    id: 8,
    label: 'VOP C16',
    layer1: {
      url: assets.img003a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1444,1630],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img003b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1408,1544],
      zoom: 0.54,
    }
  },
  {
    id: 9,
    label: 'VOP C18',
    layer1: {
      url: assets.img004a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1512,1706],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img004b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1496,1679],
      zoom: 0.54,
    }
  },
  {
    id: 10,
    label: 'VOP D14',
    layer1: {
      url: assets.img005a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1640,1833],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img005b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1637,1863],
      zoom: 0.54,
    }
  },
  {
    id: 11,
    label: 'VOP D24, D26, D28',
    layer1: {
      url: assets.img006a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1629,1861],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img006b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1617,1837],
      zoom: 0.3,
    }
  },
  {
    id: 12,
    label: 'VOP D57',
    layer1: {
      url: assets.img007a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1917,1936],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img007b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1912,1964],
      zoom: 0.54,
    }
  },
  {
    id: 13,
    label: 'VOP D95',
    layer1: {
      url: assets.img008a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1900,1931],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img008b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1914,1962],
      zoom: 0.54,
    }
  },
  {
    id: 14,
    label: 'VOP E72, E75, E77',
    layer1: {
      url: assets.img009a,
      bounds: [[0, 0], [3556, 3406]],
      center: [2066,1900],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img009b,
      bounds: [[0, 0], [3556, 3406]],
      center: [2070,1949],
      zoom: 0.54,
    }
  },
  {
    id: 15,
    label: 'VOP E17, E19',
    layer1: {
      url: assets.img010a,
      bounds: [[0, 0], [3556, 3406]],
      center: [2174,1588],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img010b,
      bounds: [[0, 0], [3556, 3406]],
      center: [2197,1621],
      zoom: 0.54,
    }
  },
  {
    id: 16,
    label: 'VOP F08',
    layer1: {
      url: assets.img011a,
      bounds: [[0, 0], [3556, 3406]],
      center: [2166,1574],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img011b,
      bounds: [[0, 0], [3556, 3406]],
      center: [2188,1526],
      zoom: 0.54,
    }
  },
  {
    id: 17,
    label: 'Juliett- & Papa-platform',
    layer1: {
      url: assets.img012a,
      bounds: [[0, 0], [3556, 3406]],
      center: [2038,837],
      zoom: 0.2,
    },
    layer2: {
      url: assets.img012b,
      bounds: [[0, 0], [3556, 3406]],
      center: [2053,841],
      zoom: 0.2,
    }
  },
  {
    id: 18,
    label: 'Yankee-platform',
    layer1: {
      url: assets.img013a,
      bounds: [[0, 0], [3556, 3406]],
      center: [1606,695],
      zoom: 0.54,
    },
    layer2: {
      url: assets.img013b,
      bounds: [[0, 0], [3556, 3406]],
      center: [1637,656],
      zoom: 0.54,
    }
  },
]
const tab01LayersOptions = tab01Layers.reduce((acc, item) => {
  return acc.concat({
    value: item.id,
    label: item.label,
  })
}, [])

const tab03Locations = [
  { value: 1, label: 'Schiphol-Oost' },
  { value: 2, label: 'Proefdraaiplaats' },
  { value: 3, label: 'Compenseerplaats' },
  { value: 4, label: 'Schiphol-Centrum' },
]
const tab03LocationsDisabledRoutes = [
  {from: 2, to: 3},
  {from: 3, to: 2}
]

class Aspect03 extends React.Component {
  state = {
    currentSubtab: false,
    currentTab: 0,
    toggleChangeLayer: false,
    currentDropdownValues: [0,0],

    tab01dropdownValue: 0,
    tab01toggleValue: false,

    tab02popup: 0,

    tab03dropdownValues: [1,4],
  }

  liftStateTab = idx => {
    this.setState({ currentTab: idx })
  }

  liftStateSubTab = idx => {
    this.setState({ currentSubtab: idx })
  }

  liftStateDropdownValues = value => {
    this.setState({ currentDropdownValues: value })
  }

  toggleChangeLayer = (e) => {
    this.setState(prevState => {
      return {
        toggleChangeLayer: !prevState.toggleChangeLayer
      }
    })
  }

  checkDropdownValues = values => {
    return values.join(',') === this.state.currentDropdownValues.join(',')
  }

  checkValues = values => {
    return values.join(',') === this.state.tab03dropdownValues.join(',')
  }

  render() {
    return (
        <div className="Chapter01-Aspect03">
          <PageContent nospacing>
            <MapWidget
                toggleChangeLayer={this.toggleChangeLayer}
                liftStateSubTab={this.liftStateSubTab}
                liftStateTab={this.liftStateTab}
                liftStateDropdownValues={this.liftStateDropdownValues}
                mapImage={mapBaseImage}
                mapBounds={[[0, 0], [3556, 3406]]}
                options={{ minZoom: -1.8 }}>

              <MapMenu>
                <MapItem label={'In- en Outbound'}>
                  <MapOverlay>
                    <Dropdown
                        style={{ maxWidth: '40rem', margin: '0 auto' }}
                        label="Locatie"
                        options={[{ value: 0, label: 'Standaard rijrichting' }, ...tab01LayersOptions]}
                        value={this.state.tab01dropdownValue}
                        onChange={value => this.setState({ tab01dropdownValue: value })} />

                    {this.state.tab01dropdownValue === 0 &&
                    <div className="Intro-message">
                      <MessageTooltip>
                        <Text>De standaardrijrichting op rijbaan A is met de klok mee. <br/>De standaardrijrichting op rijbaan B is tegen de klok in. <br/>Op het moment dat je rijbaan Alfa nadert, ga je altijd met de standaard rijrichting mee (bijvoorbeeld rijbaan A4E of A4W, rechtsaf rijbaan A);</Text>
                      </MessageTooltip>
                    </div>
                    }

                    {(this.state.tab01dropdownValue > 0 && this.state.tab01dropdownValue < 19) &&
                    <Legend onChange={value => this.setState({ tab01toggleValue: value })}
                            toggled={this.state.tab01toggleValue}
                            legend={['Inbound', 'Outbound']}
                            toggle={['De route van/naar rijbaan:', 'A', 'B']} />
                    }
                  </MapOverlay>

                  <MapLayer>
                    {tab01Layers.map(item => {
                      if(item.id === this.state.tab01dropdownValue) {
                        if(this.state.tab01toggleValue) {
                          return <Layer key={`${item.id}2`} {...item.layer2} />
                        } else {
                          return <Layer key={`${item.id}1`} {...item.layer1} />
                        }
                      }
                      return null
                    })}

                    {this.state.tab01dropdownValue === 0 &&
                    <Layer bounds={[[0,0],[0,0]]} center={[1758,1534]} zoom={-1.3} />
                    }
                  </MapLayer>
                </MapItem>

                <MapItem center={[2155,1525]} zoom={-1.8} label={'Specifieke platformen'}>
                  <MapOverlay>
                    {this.state.tab02popup === 1 &&
                    <MessageTooltip>
                      <Text>Wanneer je vanaf het Uniform-platform zonder vliegtuig naar je volgende bestemming rijdt, maak je altijd gebruik van rijbaan C of D. Wanneer je, zonder vliegtuig, van en naar het Uniform-platform rijdt, dien je gebruik te maken van rijbaan C of D.</Text>
                    </MessageTooltip>
                    }
                    {this.state.tab02popup === 2 &&
                    <MessageTooltip>
                      <Text>Wanneer je, zonder vliegtuig, van en naar het Juliett-platform rijdt, dien je gebruik te maken van de randwegen. In winterse omstandigheden kan de Papa-strook gebruikt worden voor de- en anti-icing werkzaamheden.</Text>
                    </MessageTooltip>
                    }
                    {this.state.tab02popup === 3 &&
                    <MessageTooltip>
                      <Text>Wanneer je, zonder vliegtuig, van en naar het Yankee-platform rijdt, dien je gebruik te maken van de randwegen.</Text>
                    </MessageTooltip>
                    }
                    {this.state.tab02popup === 4 &&
                    <MessageTooltip>
                      <Text>Als je vanaf het Sierra-platform naar een nieuwe bestemming rijdt, kruis je via rijbaan S2 landingsbaan 06-24. Vervolgens dien je rijbaan B te volgen, tenzij het Romeo-platform je bestemming is. Wanneer je, zonder vliegtuig, van en naar het Sierra-platform rijdt, dien je gebruik te maken van de randwegen en de Kaagbaantunnel.</Text>
                    </MessageTooltip>
                    }
                    {this.state.tab02popup === 5 &&
                    <MessageTooltip>
                      <Text>Het Mike-platform benader en verlaat je via rijbaan G.</Text>
                    </MessageTooltip>
                    }
                  </MapOverlay>

                  <MapLayer>
                    {this.state.tab02popup === 0 &&
                    <Layer url={assets.img08} bounds={[[0, 0], [3556, 3406]]} />
                    }
                    {this.state.tab02popup === 1 &&
                    <Layer url={assets.img09} bounds={[[0, 0], [3556, 3406]]} />
                    }
                    <Popup onClick={() => this.setState({ tab02popup: 1 })} position={[3034,842]} blue textCenter active={this.state.tab02popup === 1}>
                      <Text>Uniform</Text>
                    </Popup>

                    {this.state.tab02popup === 2 &&
                    <Layer url={assets.img10} bounds={[[0, 0], [3556, 3406]]} />
                    }
                    <Popup onClick={() => this.setState({ tab02popup: 2 })} position={[2157,853]} blue textCenter active={this.state.tab02popup === 2}>
                      <Text>Papa & Juliett</Text>
                    </Popup>

                    {this.state.tab02popup === 3 &&
                    <Layer url={assets.img11} bounds={[[0, 0], [3556, 3406]]} />
                    }
                    <Popup onClick={() => this.setState({ tab02popup: 3 })} position={[1605,661]} blue textCenter pinOnRight active={this.state.tab02popup === 3}>
                      <Text>Yankee</Text>
                    </Popup>

                    {this.state.tab02popup === 4 &&
                    <Layer url={assets.img12} bounds={[[0, 0], [3556, 3406]]} />
                    }
                    <Popup onClick={() => this.setState({ tab02popup: 4 })} position={[1071,1465]} blue textCenter active={this.state.tab02popup === 4}>
                      <Text>Sierra</Text>
                    </Popup>

                    {this.state.tab02popup === 5 &&
                    <Layer url={assets.img13} bounds={[[0, 0], [3556, 3406]]} />
                    }
                    <Popup onClick={() => this.setState({ tab02popup: 5 })} position={[1451,2560]} blue textCenter active={this.state.tab02popup === 5}>
                      <Text>Mike</Text>
                    </Popup>
                  </MapLayer>
                </MapItem>

                <MapItem label={'Schiphol-Oost'}>
                  <MapOverlay>
                    <DropdownMix
                        value={this.state.tab03dropdownValues}
                        options={tab03Locations}
                        disabledPairs={tab03LocationsDisabledRoutes}
                        onChange={value => this.setState({ tab03dropdownValues: value })} />
                  </MapOverlay>

                  <MapLayer>
                    {this.checkValues([1,2]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_1_2}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[1922,2557]}
                          zoom={-0.74} />
                      {checkIE11() && <Popup position={[1597,2410]} image><Image style={{"transform": "rotate(42deg)"}} src={assets.directionmarkerLeft} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([1,3]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_1_3}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[1867,2490]}
                          zoom={-0.74} />
                      {checkIE11() &&<Popup position={[1597,2410]} image><Image style={{"transform": "rotate(42deg)"}} src={assets.directionmarkerLeft} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([1,4]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_1_4}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[1820,2372]}
                          zoom={-0.74} />
                      {checkIE11() &&<Popup position={[1597,2410]} image><Image style={{"transform": "rotate(42deg)"}} src={assets.directionmarkerLeft} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([2,1]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_2_1}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[2087,2857]}
                          zoom={0} />
                      {checkIE11() &&<Popup position={[1932,2846]} image><Image style={{"transform": "rotate(42deg)"}} src={assets.directionmarkerRight} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([2,4]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_2_4}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[2116,2445]}
                          zoom={-0.74} />
                      {checkIE11() &&<Popup position={[2104,2575]} image><Image style={{"transform": "rotate(-2deg)"}} src={assets.directionmarkerLeft} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([3,1]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_3_1}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[2075,2745]}
                          zoom={-0.4} />
                      {checkIE11() &&<Popup position={[2104,2575]} image><Image style={{"transform": "rotate(-2deg)"}} src={assets.directionmarkerRight} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([3,4]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_3_4}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[2074,2267]}
                          zoom={-0.4} />
                      {checkIE11() &&<Popup position={[2077,2303]} image><Image style={{"transform": "rotate(-2deg)"}} src={assets.directionmarkerLeft} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([4,1]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_4_1}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[2139,2510]}
                          zoom={-0.74} />
                      {checkIE11() &&<Popup position={[2104,2575]} image><Image style={{"transform": "rotate(-2deg)"}} src={assets.directionmarkerRight} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([4,2]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_4_2}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[2213,2428]}
                          zoom={-0.74} />
                      {checkIE11() &&<Popup position={[2104,2575]} image><Image style={{"transform": "rotate(-2deg)"}} src={assets.directionmarkerRight} /></Popup>}
                    </React.Fragment>
                    }
                    {this.checkValues([4,3]) &&
                    <React.Fragment>
                      <Layer
                          url={assets.layer1_3_3_4_3}
                          bounds={[[0, 0], [3556, 3406]]}
                          center={[2208,2281]}
                          zoom={-0.4} />
                      {checkIE11() &&<Popup position={[2149,2359]} image><Image style={{"transform": "rotate(43deg)"}} src={assets.directionmarkerRight} /></Popup>}
                    </React.Fragment>
                    }
                  </MapLayer>
                </MapItem>

                <MapItem center={[1846,1814]} zoom={-1.8} label={'Baankruisingen'}>
                  <MapOverlay>
                    <MessageTooltip>
                      <Text>Tijdens het slepen zul je geregeld een start- en landingsbaan moeten kruisen om op je plaats van bestemming te komen. Op de kaart zie je de meest voorkomende baankruisingen.</Text>
                    </MessageTooltip>
                  </MapOverlay>

                  <MapLayer>
                    <Layer url={assets.img27} bounds={[[0, 0], [3556, 3406]]} />

                    <Popup position={[2400,676]} textCenter info>
                      <div>Kop 09</div>
                    </Popup>

                    <Popup position={[2430,1747]} textCenter info>
                      <div>Tegenover N3</div>
                    </Popup>

                    <Popup position={[2191,1743]} textCenter info>
                      <div>N3</div>
                    </Popup>

                    <Popup position={[2238,2290]} textCenter info>
                      <div>E5</div>
                    </Popup>

                    <Popup position={[2000,2286]} textCenter info>
                      <div>E3</div>
                    </Popup>

                    <Popup position={[1845,2910]} textCenter info>
                      <div>G2</div>
                    </Popup>

                    <Popup position={[1435,2538]} textCenter info>
                      <div>G4</div>
                    </Popup>

                    <Popup position={[1066,1122]} textCenter info>
                      <div>S2 Noord</div>
                    </Popup>

                    <Popup position={[830,1128]} textCenter info>
                      <div>S2 Zuid</div>
                    </Popup>

                  </MapLayer>
                </MapItem>

                <MapItem label={'Geen sleepobject'}>
                  <MapTabs className={'Tab-03'}>

                    <MapTab active label="Schiphol-Centrum" showText={
                      <div>
                        <Text>Als je zonder sleepobject rijdt, neem je op Schiphol-Centrum zoveel mogelijk de Rinse Hofstraweg en de randwegen rondom de pieren. Indien deze niet beschikbaar zijn, kun je een oversteek via de rijbanen aanvragen bij Apron Control.</Text>
                      </div>
                    }>

                      <Layer url={assets.img28} bounds={[[0, 0], [3556, 3406]]} center={[1776,1233]} zoom={-1.5}  />
                    </MapTab>

                    <MapTab label="Schiphol-Oost" showText={
                      <div>
                        <Text>Wanneer je zonder sleepobject van of naar Schiphol-Oost rijdt, zijn er twee opties:</Text>
                        <ul style={{margin: "0"}}>
                          <li>Je neemt de standaard route;</li>
                          <li>Je maakt gebruik van de Noordelijke- of Zuidelijke trekkerroute. Dit is echter alleen het geval als Apron Control je deze instructie geeft én er voldaan is aan de voorwaarden. Welke voorwaarden dit zijn leer je in hoofdstuk 2.</li>
                        </ul>
                      </div>
                    }>

                      <Layer url={assets.img29} bounds={[[0, 0], [3556, 3406]]} center={[1581,1713]} zoom={-1.8} />
                    </MapTab>

                    <MapTab label="Brede Trekker" showText={
                      <div>
                        <Text>De trekkers die inclusief spiegels breder zijn dan 3,90 meter, mogen niet overal rijden. Wegens hun breedte is het namelijk niet overal mogelijk om de bochten te maken zonder andere voertuigen te belemmeren of te beschadigen. Op de kaart zie je waar je <strong>niet</strong> met een brede trekker mag rijden.</Text>
                      </div>
                    }>

                      <Layer url={assets.img30} bounds={[[0, 0], [3556, 3406]]} center={[1708,1236]} zoom={-1.5}  />
                    </MapTab>

                  </MapTabs>
                </MapItem>
              </MapMenu>

            </MapWidget>
          </PageContent>

          {this.state.currentTab === 4 &&
          <PageFooter>
            <Message title="Let op!">
              <Text>Als je je zonder sleepobject over het terrein moet verplaatsen is achteruitrijden, vanwege aanrijdingsgevaar, niet toegestaan. Je verplaatst daarom alleen vooruit, over de verschillende dienstwegen, randwegen en rijbanen.</Text>
            </Message>
          </PageFooter>
          }
        </div>
    )
  }
}

export default Aspect03



// WEBPACK FOOTER //
// ./src/content/chapters/01/03/Aspect03.js